/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Finnish
export default {
  'automation-menu.empty-state.image.alt': 'Tyhjän automaatioluettelon kuvake',
  'automation-menu.empty-state.learn-more.link': 'Lue lisää manuaalisesta laukaisimesta',
  'automation-menu.modal.empty.automations.admin.description':
    'Täytä manuaalisen laukaisimen avulla valikko valinnoilla, joita kuka tahansa tai määrittämäsi henkilöt voivat käyttää yhden napsautuksen automaatioina.',
  'automation-menu.modal.empty.automations.user.description':
    'Ylläpitäjät eivät ole vielä määrittäneet yhtään manuaalisesti laukaistavaa automaatiota.',
  'automation-menu.modal.error.description': 'Lataaminen kestää jonkin aikaa. Yritä päivittää sivu.',
  'automation-menu.modal.error.image.alt': 'Virhekuvake',
  'automation-menu.modal.footer.automate-button': 'Automatisoi',
  'automation-menu.modal.footer.cancel-button': 'Peruuta',
  'automation-menu.modal.footer.get-started-button': 'Luo automaatio',
  'automation-menu.modal.footer.ok-button': 'OK',
  'automation-menu.modal.header.icon.label': 'Automaation modaalisen ikkunan ylätunnisteen kuvake',
  'automation-menu.success-state.message': 'Automaatio on käynnissä',
  'fabric.linking.access_exists_description': 'Pyydä oikeutta tarkastella tätä sisältöä kohteesta {hostname}.',
  'fabric.linking.actions': 'Toiminnot',
  'fabric.linking.add_account': 'Lisää tili',
  'fabric.linking.ai_summarize': 'Tee yhteenveto',
  'fabric.linking.ai_summarized': 'Atlassian Intelligence loi yhteenvedon',
  'fabric.linking.ai_summarized_abbreviation': 'Yhteenvedon loi AI',
  'fabric.linking.ai_summarized_info': 'Tietojen laatu voi vaihdella. <a>Lue lisää.</a>',
  'fabric.linking.ai_summarized_info_short': 'Sisällön laatu voi vaihdella',
  'fabric.linking.ai_summarizing': 'Atlassian Intelligence työssä...',
  'fabric.linking.ai_summary_action': 'Tee yhteenveto AI:lla',
  'fabric.linking.ai_summary_action_description': 'Tee yhteenveto tämän linkin sisällöstä Atlassian Intelligencellä.',
  'fabric.linking.ai_summary_error_acceptable_use_violation':
    'Tämän yhteenvedon tuloksia ei voida näyttää, sillä se ei noudata <a>Atlassianin hyväksyttävän käytön käytäntöä</a>.',
  'fabric.linking.ai_summary_error_exceeding_context_length_error':
    'Atlassian Intelligence ei voi luoda yhteenvetoa sinulle juuri nyt, koska sisältöä on liian paljon.',
  'fabric.linking.ai_summary_error_generic':
    'Atlassian Intelligence (AI) ei vastaa. Yritä myöhemmin uudelleen tai <a>tarkista AI:n tila</a>.',
  'fabric.linking.ai_summary_error_hipaa_content_detected':
    'Atlassian Intelligence ei pystynyt käsittelemään pyyntöäsi, koska sisältösi sisältää linkkejä HIPAA-rajoitettuun sisältöön.',
  'fabric.linking.assigned_to': 'Määrätty käyttäjälle {context}',
  'fabric.linking.automation-action.confluence.page.modal.description':
    'Käytä automaatiota sivulla <b>{name}</b>.{br}Confluencen ja työtilan ylläpitäjät hallitsevat käytettävissä olevia valintoja.',
  'fabric.linking.automation-action.confluence.page.modal.title': 'Sivun automaatiot',
  'fabric.linking.automation-action.icon.label': 'Automaatiokuvake',
  'fabric.linking.automation-action.title': 'Näytä automaatiosäännöt',
  'fabric.linking.automation-action.tooltip': 'Valitse suoritettava automaatiosääntö',
  'fabric.linking.beta': 'Beeta',
  'fabric.linking.cancel': 'Peruuta',
  'fabric.linking.cannot_connect': 'Ei voi muodostaa yhteyttä, yritä uudelleen',
  'fabric.linking.cannot_find_link': 'Linkkiä ei löydy',
  'fabric.linking.check_this_link': 'Tarkista tämä linkki',
  'fabric.linking.click_to_join': 'Liity käyttämään tuotetta {context}',
  'fabric.linking.click_to_join_description':
    'Sinut on hyväksytty, joten voit liittyä heti tuotteen {context} käyttäjäksi.',
  'fabric.linking.close': 'Sulje',
  'fabric.linking.connect_account_description':
    'Avaamme uuden sivun, jotta voimme auttaa sinua yhdistämään {name} -tilisi',
  'fabric.linking.connect_link_account': 'Yhdistä esikatseluun',
  'fabric.linking.connect_link_account_card_view': 'Yhdistä',
  'fabric.linking.connect_link_account_card_view_description':
    'Jotta voit esikatsella tätä linkkiä, yhdistä {context}-tilisi.',
  'fabric.linking.connect_link_account_card_view_name': 'Yhdistä {context}-tilisi',
  'fabric.linking.connect_to': 'Yhdistä kohteeseen {name}',
  'fabric.linking.connect_unauthorised_account_action': 'Yhdistä kohteeseen {context}',
  'fabric.linking.connect_unauthorised_account_description':
    'Yhdistä palvelun {context} tilisi ja tee yhteistyötä eri Atlassian-tuotteissa.',
  'fabric.linking.connect_unauthorised_account_description_no_provider':
    'Yhdistä tilisi ja tee yhteistyötä eri Atlassian-tuotteissa.',
  'fabric.linking.continue': 'Jatka',
  'fabric.linking.copied_summary_action_description': 'Yhteenveto kopioitu leikepöydälle',
  'fabric.linking.copied_url_to_clipboard': 'Kopioitu!',
  'fabric.linking.copy_summary_action': 'Kopioi yhteenveto',
  'fabric.linking.copy_summary_action_description': 'Kopioi yhteenveto',
  'fabric.linking.copy_url_to_clipboard': 'Kopioi linkki',
  'fabric.linking.couldnt_load_link': 'Tämän linkin lataaminen epäonnistui tuntemattomasta syystä.',
  'fabric.linking.create_on_absolute': 'Luotiin {context}',
  'fabric.linking.create_on_relative': 'Luotu {context}',
  'fabric.linking.created_by': 'Tekijä: {context}',
  'fabric.linking.delete': 'Poista',
  'fabric.linking.direct_access': 'Liity nyt',
  'fabric.linking.direct_access_description':
    '{product} on tiimisi käytössä yhteistyön tukena, ja voit aloittaa sen käytön heti!',
  'fabric.linking.direct_access_title': 'Näytä tämä sisältö liittymällä {product}-palveluun',
  'fabric.linking.download': 'Lataa',
  'fabric.linking.download_description': 'Lataa tämä tiedosto paikalliseen tallennustilaan',
  'fabric.linking.download_file': 'Lataa tiedosto',
  'fabric.linking.edit': 'Muokkaa',
  'fabric.linking.follow': 'Seuraa',
  'fabric.linking.follow_goal': 'Seuraa päämäärää',
  'fabric.linking.follow_goal_description': 'Seuraamalla tätä päämäärää saat ilmoituksia päivityksistä',
  'fabric.linking.follow_goal_error':
    'Kohtasimme virheen yrittäessämme seurata päämäärää. Tarkista verkkoyhteytesi tai päivitä sivu ja yritä uudelleen.',
  'fabric.linking.follow_project': 'Seuraa projektia',
  'fabric.linking.follow_project_description': 'Seuraamalla saat ilmoituksia tästä projektista',
  'fabric.linking.follow_project_error':
    'Kohtasimme virheen yrittäessämme seurata projektia. Tarkista verkkoyhteytesi tai päivitä sivu ja yritä uudelleen.',
  'fabric.linking.forbidden_access': 'Pääsy on kielletty',
  'fabric.linking.forbidden_description':
    'Ota yhteyttä ylläpitäjääsi oikeuden pyytämistä varten kohteeseen {hostname}.',
  'fabric.linking.forbidden_title': 'Sinulla ei ole oikeutta tähän sisältöön',
  'fabric.linking.generic_error_message': 'Tapahtui virhe',
  'fabric.linking.go_back': 'Siirry takaisin',
  'fabric.linking.invalid_permissions': 'Rajoitettu sisältö',
  'fabric.linking.invalid_permissions_description':
    'Pyydä käyttöoikeus tai käytä toista tiliä, jos haluat nähdä tämän esikatselun.',
  'fabric.linking.join_to_view': 'Liity palveluun {context} niin voit tarkastella asiaa',
  'fabric.linking.join_to_view-issue-term-refresh': 'Liity palveluun {context} voidaksesi tarkastella työtehtävää',
  'fabric.linking.learn_more_about_connecting_account': 'Lisätietoja tilisi yhdistämisestä Atlassian-tuotteisiin.',
  'fabric.linking.learn_more_about_smart_links': 'Lue lisää Smart Link -linkeistä.',
  'fabric.linking.link_safety_warning_message':
    'Linkki {unsafeLinkText} vie sinut toiseen sivustoon: <a>actual link here</a>',
  'fabric.linking.loading': 'Ladataan...',
  'fabric.linking.modified_on_absolute': 'Päivitetty {context}',
  'fabric.linking.modified_on_relative': 'Päivitetty {context}',
  'fabric.linking.more_actions': 'Lisää toimintoja',
  'fabric.linking.more_information_about_this_work_item': 'Lisätietoja tästä työtehtävästä',
  'fabric.linking.no_access_title': 'Näytä tämä sisältö liittymällä {product}-palveluun',
  'fabric.linking.not_found_description':
    'Sivua ei ole olemassa, tai sitä on saatettu muuttaa tämän linkin lisäämisen jälkeen.',
  'fabric.linking.not_found_title': 'Tätä {product}-sivua ei voida näyttää',
  'fabric.linking.open_issue_in_jira': 'Avaa asia Jirassa',
  'fabric.linking.open_issue_in_jira-issue-term-refresh': 'Avaa työtehtävä Jirassa',
  'fabric.linking.open_link_in_a_new_tab': 'Avaa linkki uudessa välilehdessä',
  'fabric.linking.owned_by': 'Omistaja: {context}',
  'fabric.linking.pending_request': 'Käyttöoikeuspyyntösi on vireillä',
  'fabric.linking.preview_close': 'Sulje esikatselu',
  'fabric.linking.preview_description': 'Avaa tämän linkin koko näytön esikatselu',
  'fabric.linking.preview_improved': 'Avaa esikatselu',
  'fabric.linking.preview_max_size': 'Näytä koko näytöllä',
  'fabric.linking.preview_min_size': 'Sulje koko näytön tila',
  'fabric.linking.priority_blocker': 'Esto',
  'fabric.linking.priority_critical': 'Kriittinen',
  'fabric.linking.priority_high': 'Korkea',
  'fabric.linking.priority_highest': 'Korkein',
  'fabric.linking.priority_low': 'Matala',
  'fabric.linking.priority_lowest': 'Matalin',
  'fabric.linking.priority_major': 'Suuri',
  'fabric.linking.priority_medium': 'Keskitaso',
  'fabric.linking.priority_minor': 'Vähäinen',
  'fabric.linking.priority_trivial': 'Mitätön',
  'fabric.linking.priority_undefined': 'Määrittelemätön',
  'fabric.linking.read_time': 'Lukuaika: {context}',
  'fabric.linking.related': 'Liittyvät',
  'fabric.linking.related_links_found_in': 'Löydetty kohteesta',
  'fabric.linking.related_links_includes_links_to': 'Sisältää linkit kohteeseen',
  'fabric.linking.related_links_modal_error_header': 'Jokin meni vikaan',
  'fabric.linking.related_links_modal_error_message':
    'Viimeaikaisten linkkien latauksen aikana ilmeni ongelma. Tarkista yhteys tai päivitä sivu ja yritä uudelleen.',
  'fabric.linking.related_links_modal_title': 'Viimeaikaiset linkit',
  'fabric.linking.related_links_modal_unavailable_header': 'Ei viimeaikaisia linkkejä',
  'fabric.linking.related_links_modal_unavailable_message':
    'Täältä ei löytynyt näytettäviä linkkejä. Päivitettyjen sivujen tai muiden sisältötyyppien viimeaikaisia linkkejä tarkistetaan ja lisätään jatkuvasti.',
  'fabric.linking.related_links_not_found': 'Täältä ei löytynyt näytettäviä linkkejä.',
  'fabric.linking.related_links_view_related_urls': 'Näytä viimeisimmät linkit',
  'fabric.linking.request_access': 'Pyydä pääsyä',
  'fabric.linking.request_access_description':
    '{product} on tiimisi käytössä yhteistyön tukena. Pyydä käyttöoikeutta ylläpitäjältäsi.',
  'fabric.linking.request_access_pending': 'Odottaa hyväksyntää',
  'fabric.linking.request_access_pending_description':
    'Oikeuspyyntösi kohteelle {hostname} odottaa ylläpitäjän hyväksyntää.',
  'fabric.linking.request_access_pending_title': 'Oikeus tuotteeseen {product} odottaa',
  'fabric.linking.request_access_to_view': 'Pyydä palvelun {context} käyttöoikeutta tämän asian tarkastelua varten',
  'fabric.linking.request_access_to_view-issue-term-refresh':
    'Pyydä palvelun {context} käyttöoikeutta tämän työtehtävän tarkastelua varten',
  'fabric.linking.request_denied': 'Käyttöoikeuspyyntösi evättiin',
  'fabric.linking.request_denied_description':
    'Ylläpitäjä ei hyväksynyt pyyntöäsi tarkastella {product}-sivuja kohteesta {hostname}.',
  'fabric.linking.restricted_link': 'Rajoitettu linkki, kokeile toista tiliä',
  'fabric.linking.retry': 'Yritä uudelleen',
  'fabric.linking.save': 'Tallenna',
  'fabric.linking.sent_on_absolute': 'Lähetetty {context}',
  'fabric.linking.sent_on_relative': 'Lähetetty {context}',
  'fabric.linking.srclink': 'Näytä kohteessa',
  'fabric.linking.srclinkunknown': 'Näytä alkuperäinen',
  'fabric.linking.status_change_load_error': 'Tiloja ja siirtymiä ei voitu ladata',
  'fabric.linking.status_change_permission_error': 'Sinulla ei ole oikeuksia siirtää tätä asiaa.',
  'fabric.linking.status_change_permission_error-issue-term-refresh':
    'Sinulla ei ole oikeuksia siirtää tätä työtehtävää.',
  'fabric.linking.status_change_update_error': 'Tilan päivitys epäonnistui',
  'fabric.linking.try_again': 'Yritä uudelleen',
  'fabric.linking.try_another_account': 'Kokeile toista tiliä',
  'fabric.linking.unassigned': 'Määräämätön',
  'fabric.linking.unauthorised_account_description':
    'Yrität esikatsella yksityisen {context}-sivun linkkiä. Suosittelemme, että tarkistat URL-osoitteen tai otat yhteyden sivun omistajaan.',
  'fabric.linking.unauthorised_account_description_no_provider':
    'Yrität esikatsella yksityisen sivun linkkiä. Suosittelemme, että tarkistat URL-osoitteen tai otat yhteyden sivun omistajaan.',
  'fabric.linking.unauthorised_account_name': 'Yksityisiä sivuja ei voida näyttää kohteesta {context}',
  'fabric.linking.unauthorised_account_name_no_provider': 'Yksityisiä sivuja ei voida näyttää',
  'fabric.linking.unfollow': 'Lopeta seuraaminen',
  'fabric.linking.unfollow_goal': 'Lopeta tavoitteen seuraaminen',
  'fabric.linking.unfollow_goal_description': 'Lopeta seuraaminen, niin et enää saa ilmoituksia tästä tavoitteesta',
  'fabric.linking.unfollow_goal_error':
    'Kohtasimme virheen yrittäessämme lopettaa tavoitteen seuraamisen. Tarkista verkkoyhteytesi tai päivitä sivu ja yritä uudelleen.',
  'fabric.linking.unfollow_project': 'Lopeta projektin seuraaminen',
  'fabric.linking.unfollow_project_description': 'Lopeta seuraaminen, niin et enää saa projekti-ilmoituksia',
  'fabric.linking.unfollow_project_error':
    'Löysimme virheen yrittäessämme lopettaa projektin seuraamisen. Tarkista verkkoyhteytesi tai päivitä sivu ja yritä uudelleen.',
  'fabric.linking.unlink_account': 'Poista tilin linkitys',
  'fabric.linking.updated_by': 'Muokannut: {context}',
  'fabric.linking.view': 'Näytä',
};
